export default function Footer() {
  const currentYear = new Date().getFullYear();

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-gradient-to-br from-orange-600 via-red-600 to-red-700 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* About */}
          <div>
            <img
              src="https://static.readdy.ai/image/44113e0bd02cf9d4b6e5b2a3bf2fb8ec/4985716b622c6bd23d7a1f6630e52c55.png"
              alt="Logo"
              className="h-16 w-auto mb-4"
            />
            <p className="text-white/90 text-sm leading-relaxed">
              Tu tienda de productos mexicanos, hondureños, salvadoreños y nicaragüenses en Indianápolis. Sabores auténticos de Centroamérica a tu alcance.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-bold mb-4">Enlaces Rápidos</h4>
            <ul className="space-y-3">
              <li>
                <button
                  onClick={() => scrollToSection('inicio')}
                  className="text-white/90 hover:text-white text-sm transition-colors cursor-pointer whitespace-nowrap"
                >
                  Inicio
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('sobre-nosotros')}
                  className="text-white/90 hover:text-white text-sm transition-colors cursor-pointer whitespace-nowrap"
                >
                  Sobre Nosotros
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('productos')}
                  className="text-white/90 hover:text-white text-sm transition-colors cursor-pointer whitespace-nowrap"
                >
                  Productos
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('contacto')}
                  className="text-white/90 hover:text-white text-sm transition-colors cursor-pointer whitespace-nowrap"
                >
                  Contacto
                </button>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-lg font-bold mb-4">Contacto</h4>
            <ul className="space-y-3 text-sm">
              <li className="flex items-start gap-2">
                <i className="ri-map-pin-line text-lg flex-shrink-0 mt-0.5"></i>
                <span className="text-white/90">4051 Carson Ave, Indianapolis, IN 46227</span>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-phone-line text-lg flex-shrink-0 mt-0.5"></i>
                <span className="text-white/90">(317) 279-0334</span>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-mail-line text-lg flex-shrink-0 mt-0.5"></i>
                <span className="text-white/90">labonitamarkett@gmail.com</span>
              </li>
            </ul>
          </div>

          {/* Hours & Social */}
          <div>
            <h4 className="text-lg font-bold mb-4">Horario</h4>
            <ul className="space-y-2 text-sm text-white/90 mb-6">
              <li className="flex justify-between">
                <span>Lunes - Domingo:</span>
                <span className="font-semibold">8AM - 10:30PM</span>
              </li>
            </ul>
            
            {/* Social Media */}
            <h4 className="text-lg font-bold mb-4">Síguenos</h4>
            <div className="flex gap-3 mb-6">
              <a
                href="https://www.instagram.com/labonitamarkett/"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-gradient-to-br from-purple-500 via-pink-500 to-orange-500 rounded-lg flex items-center justify-center hover:scale-110 transition-transform cursor-pointer"
                aria-label="Instagram"
              >
                <i className="ri-instagram-line text-xl text-white"></i>
              </a>
              <a
                href="https://www.tiktok.com/@labonitamarket?is_from_webapp=1&sender_device=pc"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-black rounded-lg flex items-center justify-center hover:scale-110 transition-transform cursor-pointer"
                aria-label="TikTok"
              >
                <i className="ri-tiktok-line text-xl text-white"></i>
              </a>
            </div>

            <div>
              <a
                href="https://wa.me/13172790334"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 bg-green-500 hover:bg-green-600 text-white px-6 py-3 rounded-full text-sm font-semibold transition-all shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
              >
                <i className="ri-whatsapp-line text-lg"></i>
                WhatsApp
              </a>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-white/20 mt-12 pt-8">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            <p className="text-sm text-white/80">
              © {currentYear} Tienda Centroamericana. Todos los derechos reservados.
            </p>
            <a
              href="https://readdy.ai/?origin=logo"
              target="_blank"
              rel="noopener noreferrer"
              className="text-sm text-white/80 hover:text-white transition-colors whitespace-nowrap"
            >
              Website Builder
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
